import React from "react";
import { Row, Col, Form } from 'react-bootstrap';
import { NumericFormat as NumberFormat } from "react-number-format";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { currency } from "../../../../../utils/number";

class detail extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.mapPropsToState(props)
    }

    mapPropsToState = (props) => {
        const {
            uuid,
            code,
            description,
            caption,
            merchant,
            quantity,
            each,
            begins,
            ends,
            minimum,
            maximum
        } = props;

        return {
            uuid,
            code,
            description,
            caption,
            merchant,
            quantity,
            each,
            begins,
            ends,
            minimum,
            maximum,
            extended: quantity * each
        }
    }

    onQtyChange = (e) => {
        let quantity = Math.min(this.state.maximum, e.floatValue);
        quantity = Math.max(quantity, this.state.minimum);

        this.setState(prev => ({
            quantity,
            extended: quantity * prev.each
        }), this.doPostChange);
    }

    onEachChange = (e) => {
        this.setState(prev => ({
            each: e.floatValue,
            extended: prev.quantity * e.floatValue
        }), this.doPostChange);
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        }, this.doPostChange)
    }

    doPostChange = (e) => {
        const { quantity, caption, each, extended } = this.state;
        if (this.props.onChange) this.props.onChange({ quantity, caption, each, extended });
    }

    render() {

        return (
            <Row className="g-3 pb-3">
                <Col xs="12" md="2">
                    <div className="top-label">
                        <NumberFormat
                            displayType="input"
                            type="text"
                            id="qty"
                            name="qty"
                            className="text-end form-control mb-2"
                            thousandSeparator={true}
                            allowNegative={false}
                            value={this.state.quantity || 0}
                            onValueChange={this.onQtyChange}
                            removeFormatting
                        />
                        <Form.Label>QTY</Form.Label>
                    </div>
                </Col>
                <Col xs="12" md="5">
                    <div className="top-label">
                        <Form.Control type="text" name="caption" value={this.state.caption || ""} onChange={this.onChange} />
                        <Form.Label>ITEM</Form.Label>
                    </div>
                </Col>
                <Col xs="12" md="2">
                    <div className="top-label">
                        <NumberFormat
                            displayType="input"
                            type="text"
                            id="each"
                            name="each"
                            prefix={"$"}
                            className="text-end form-control mb-2"
                            thousandSeparator={true}
                            allowNegative={false}
                            value={this.state.each || 0}
                            onValueChange={this.onEachChange}
                            removeFormatting
                        />
                        <Form.Label>EACH</Form.Label>
                    </div>
                </Col>
                <Col xs="12" md="3">
                    <div className="top-label mt-3 text-end">
                        {currency(this.state.extended)}
                    </div>
                </Col>
            </Row>
        );
    }
}

detail.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps)(detail);